import { render, staticRenderFns } from "./RevisedByContainsFilter.vue?vue&type=template&id=38cec3dc"
import script from "./RevisedByContainsFilter.vue?vue&type=script&lang=js"
export * from "./RevisedByContainsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports